export default "__VITE_ASSET__2c219822__"